import React from 'react'
import { useDispatch } from 'react-redux'

import { selectCandidates } from 'ducks/concurrency'
import { useCandidateGroupData, useModal, useSnackbar } from 'hooks'

const useSelectCandidateGroupModalMutations = () => {
  const dispatch = useDispatch()

  const handleSelectCandidates = React.useCallback(
    ({ projectId }, { onShowSnackbar }) => {
      dispatch(selectCandidates({ projectId }, { onShowSnackbar }))
    },
    [dispatch],
  )

  return {
    handleSelectCandidates,
  }
}

export const useSelectCandidateGroupModalState = () => {
  const {
    state: { candidates, count, pks },
  } = useCandidateGroupData()

  return {
    state: {
      candidates,
      count,
      pks,
    },
  }
}

export const useSelectCandidateGroupModal = state => {
  const { projectId } = state

  const { isOpen, handleClose, handleOpen } = useModal()

  const {
    handlers: { handleShowSnackbar },
  } = useSnackbar()

  const { handleSelectCandidates } = useSelectCandidateGroupModalMutations()

  const handleConfirm = React.useCallback(() => {
    handleSelectCandidates(
      { projectId },
      { onShowSnackbar: handleShowSnackbar },
    )
    handleClose()
  }, [projectId, handleClose, handleSelectCandidates, handleShowSnackbar])

  return {
    handleSelectCandidateGroupModalClose: handleClose,
    handleSelectCandidateGroupModalConfirm: handleConfirm,
    handleSelectCandidateGroupModalOpen: handleOpen,
    isSelectCandidateGroupModalOpen: isOpen,
  }
}
